<template>
  <nav class="mega-menu mega-menu--content-hub" data-gtm-context="Content Hub Menu">
    <ul class="mega-menu__list">
      <li>
        <a class="mega-menu__item" href="/blog/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Blog</h6>
            <p class="mega-menu__description">Insights, tips and announcements</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/infographics/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M7 17v-4"/><path d="M12 17V7"/><path d="M17 17v-8"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Infographics</h6>
            <p class="mega-menu__description">Download and share our visual guides</p>
          </div>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "ContentHubMenu",
};
</script>
